import Menu from './components/Menu'

export const components = {
  Menu,
}
